import {
    Button,
    Card,
    Input,
    Modal,
    notification,
    Skeleton,
    Form,
    Popconfirm,
    Select,
    Tooltip,
} from "antd";
import PhoneInput from "react-phone-input-2";
import React, { useEffect, useState } from "react";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import {
    DeleteTwoTone,
    EditTwoTone,
    PlusOutlined,
    QuestionCircleOutlined,
} from "@ant-design/icons";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";
import { getUserRole, vendorTypes } from "../../services/util";

const { Option } = Select;

function VendorList() {
    const [form] = Form.useForm();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const userRole = getUserRole();
    const [searchKey, setSearchKey] = useState("");
    const [formData, setFormData] = useState({
        staff_id,
        sort_by: "id",
        sorting: 1,
        page: 0,
        limit: 10,
        filters: {},
        search_by: searchKey,
    });
    const [formPhoneInputValue, setFormPhoneInputValue] = useState([]);
    const [vendorData, setVendorData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [title, setTitle] = useState("Edit");
    const [hotelOptions, setHotelOptions] = useState([]);
    const columns = [
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
            sorter: () => {},
            width: 100,
        },
        {
            title: "Vendor",
            dataIndex: "vendor_name",
            key: "vendor_name",
            sorter: () => {},
        },
        {
            title: "Person Name",
            dataIndex: "person_name",
            key: "person_name",
            sorter: () => {},
        },
        {
            title: "Email",
            dataIndex: "person_email",
            key: "person_email",
            sorter: () => {},
        },
        {
            title: "Hotel",
            dataIndex: "hotel_id",
            key: "hotel_id",
            render: (record) =>
                record &&
                record.map((item) => {
                    const hotel_details = hotelOptions.find(
                        (e) => e.hotel_id == item,
                    );
                    return (
                        <React.Fragment key={String(Math.random())}>
                            <span>{hotel_details?.hotel_name}</span>
                            <br />
                        </React.Fragment>
                    );
                }),
        },
        {
            title: "Vendor Type",
            dataIndex: "vendor_type",
            key: "vendor_type",
            filters: [
                ...vendorTypes.map((v) => {
                    return { text: v.name, value: v.key };
                }),
            ],
            render: (text) => {
                return vendorTypes.find((v) => v.key == text)?.name;
            },
            width: "10%",
            // sorter: () => {},
        },
        {
            title: "Phone",
            render: (_, record) =>
                `${record.country_code} - ${record.phone_number}`,
        },
        {
            title: "Notes",
            dataIndex: "notes",
            key: "notes",
            render: (text) => (
                <Tooltip placement="rightTop" title={text}>
                    <span>
                        {text.length <= 20
                            ? text
                            : `${text.substring(0, 20)}...`}
                    </span>
                </Tooltip>
            ),
            sorter: () => {},
        },
        {
            title: "Action",
            fixed: "right",
            width: 75,
            render: (text, record) => {
                return (
                    <>
                        <Popconfirm
                            title="Are you sure want to delete?"
                            onConfirm={() => deleteUser(record.id)}
                            icon={
                                <QuestionCircleOutlined
                                    style={{
                                        color: "red",
                                    }}
                                />
                            }
                        >
                            <DeleteTwoTone className="actionIcon actionIconDelete" />
                        </Popconfirm>
                        <EditTwoTone
                            className="actionIcon"
                            id={record.id}
                            details={JSON.stringify(record)}
                            onClick={editUser}
                        />
                    </>
                );
            },
        },
    ];

    const {
        status: vendorStatus,
        data: vendorRes,
        refetch: getVendor,
    } = useQuery(
        "dashboard-vendors",
        async () => {
            return await HTTP("/vendors/getVendors", {
                ...formData,
            });
        },
        { enabled: false },
    );

    const {
        status: hotelStatus,
        data: hotelData,
        refetch: getHotelSelectionOptions,
    } = useQuery(
        "analytics-hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", {
                staff_id,
                hotel_type: "all",
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getHotelSelectionOptions();
        getVendor();
    }, []);

    useEffect(() => {
        getVendor();
    }, [formData]);

    useEffect(() => {
        if (vendorStatus === "success") {
            const { data: vendorData, total } = vendorRes;
            setVendorData(vendorData);
            setTotalRecords(total);
        }
    }, [vendorStatus, vendorRes]);

    useEffect(() => {
        if (hotelStatus === "success") {
            setHotelOptions(hotelData.data);
        }
    }, [hotelStatus, hotelData]);

    async function deleteUser(id) {
        const formData = {
            staff_id,
            id,
        };
        const { success, message } = await HTTP(
            "/vendors/deleteVendor",
            formData,
        );
        if (success === 0) {
            return notification["error"]({
                message: message,
            });
        } else {
            notification["info"]({
                message: "Delete action performed successfully.",
            });
        }
        getVendor();
    }

    function editUser(e) {
        const details = JSON.parse(e.currentTarget.getAttribute("details"));
        setTitle("Edit");
        details.phone_number = details.country_code
            .concat(details.phone_number)
            .replace("+", "");
        setFormPhoneInputValue([details.country_code, details.phone_number]);
        form.setFieldsValue(details);
        setVisible(true);
    }

    function openAddVendorModel() {
        setTitle("Add");
        form.resetFields();
        setVisible(true);
    }

    function closeModel() {
        setVisible(false);
        setFormPhoneInputValue([]);
        form.resetFields();
    }

    async function handleSubmit(formData) {
        closeModel();
        formData.staff_id = staff_id;
        let url;
        if (formData.id) {
            url = "/vendors/editVendor";
        } else {
            url = "/vendors/addVendor";
            delete formData["id"];
        }
        const [country_code, phone_number] = formPhoneInputValue;
        formData.country_code = country_code;
        formData.phone_number = phone_number;
        const { success, message } = await HTTP(url, formData);
        let type = "info";
        if (success === 0) {
            type = "error";
        }
        notification[type]({
            message: message,
        });
        getVendor();
    }

    function handlePhoneInputChange(value, country, e, formattedValue) {
        setFormPhoneInputValue([
            `+${country.dialCode}`,
            value.replace(country.dialCode, ""),
        ]);
    }

    function handleTableChange(pagination, filters, sorter, extra) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
            sort_by: "id",
            sorting: 1,
            ...(filters?.vendor_type ? { filters } : { filters: {} }),
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        }
        const formData = {
            staff_id,
            ...others,
        };
        setFormData(formData);
    }

    function handleSearchInputSubmit() {
        const updatedFormData = { ...formData, search_by: searchKey };
        setFormData(updatedFormData);
    }

    function handleSearchInputChange(event) {
        setSearchKey(event.target.value);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader
                    extraAfter={
                        (userRole === "Super Admin" ||
                            userRole === "Admin" ||
                            userRole === "Customer Success" ||
                            userRole == "Support") && (
                            <Button
                                type="primary"
                                style={{ marginRight: "5px" }}
                                onClick={openAddVendorModel}
                            >
                                <PlusOutlined /> Add
                            </Button>
                        )
                    }
                />
                <Card
                    className="box-shadow margin-10"
                    title={
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Input
                                placeholder="Search By"
                                style={{ width: "20%" }}
                                className="margin-right-10"
                                value={searchKey}
                                onChange={handleSearchInputChange}
                            />
                            <Button
                                type="primary"
                                onClick={handleSearchInputSubmit}
                            >
                                Search
                            </Button>
                        </div>
                    }
                >
                    {vendorStatus === "loading" || vendorStatus === "idle" ? (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    ) : (
                        <CustomTable
                            columns={columns}
                            tableData={vendorData}
                            noOfrecords={totalRecords}
                            handleTableChange={handleTableChange}
                            rowKey="id"
                            className="dashboard-table"
                            isScroll
                        />
                    )}
                </Card>
            </Card>
            <Modal
                title={title}
                open={visible}
                footer=""
                onCancel={closeModel}
                destroyOnClose={true}
                className="test"
            >
                <Form
                    form={form}
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    onFinish={handleSubmit}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Vendor Name"
                        name="vendor_name"
                        rules={[
                            {
                                required: true,
                                message: "Please enter vendor name!",
                            },
                        ]}
                    >
                        <Input
                            placeholder="Vendor Name"
                            id="vendor_name"
                            className="upcoming-form-inputs"
                        ></Input>
                    </Form.Item>

                    <Form.Item
                        label="Person Name"
                        name="person_name"
                        rules={[
                            {
                                required: true,
                                message: "Please enter person name!",
                            },
                        ]}
                    >
                        <Input
                            placeholder="Person Name"
                            id="person_name"
                            className="upcoming-form-inputs"
                        ></Input>
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="person_email"
                        rules={[
                            {
                                type: "email",
                                required: true,
                                message: "Please enter email!",
                            },
                        ]}
                    >
                        <Input
                            placeholder="Email"
                            id="person_email"
                            className="upcoming-form-inputs"
                        ></Input>
                    </Form.Item>

                    <Form.Item label="Hotels" name="hotel_id">
                        <Select
                            id="hotel_id"
                            placeholder="Hotel Name"
                            className="jira-dashboard-select"
                            showSearch
                            mode="multiple"
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            loading={hotelOptions.length == 0}
                        >
                            {hotelOptions.map((h) => (
                                <Option
                                    key={h.hotel_id || h.id}
                                    value={h.hotel_id || h.id}
                                >
                                    {`${h.hotel_id || h.id} - ${
                                        h.hotel_name || h.name
                                    } - ${h.city}`}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Vendor Type"
                        name="vendor_type"
                        rules={[
                            {
                                required: true,
                                message: "Please Select vendor Type..!",
                            },
                        ]}
                    >
                        <Select
                            id="vendor_type"
                            placeholder="Vendor Type"
                            className="jira-dashboard-select"
                        >
                            {vendorTypes.map((v) => (
                                <Option key={v.key} value={v.key}>
                                    {v.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Phone"
                        name="phone_number"
                        rules={[
                            {
                                required: true,
                                message: "Please enter phone!",
                            },
                        ]}
                    >
                        <PhoneInput
                            onChange={handlePhoneInputChange}
                            placeholder="Phone"
                            id="phone_number"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Notes"
                        name="notes"
                        rules={[
                            {
                                required: true,
                                message: "Please enter notes!",
                            },
                        ]}
                    >
                        <Input.TextArea
                            placeholder="Notes"
                            id="notes"
                            className="upcoming-form-inputs"
                        />
                    </Form.Item>

                    <Form.Item label="Id" name="id" className="hidden">
                        <Input
                            id="id"
                            className="upcoming-form-inputs"
                            disabled
                        ></Input>
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export { VendorList };
